exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".signature-container {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-align: center;\n        align-items: center;\n}\n\n#signatureCanvas {\n    border: 2px solid black;\n    background-color: transparent; /* Ensures transparency */\n    width: 95%;\n    max-width: 400px;\n}\n\n.signatureButton {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding: 12px 30px;\n    border: none;\n    background-color: #48a69c;\n    color: white;\n    cursor: pointer;\n    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);\n    border-radius: 2px;\n}\n\n.signatureButton:hover {\n    background-color: #255752;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/signature/signature.component.css
// module id = ../../../../../src/app/components/signature/signature.component.css
// module chunks = main